import { PropsWithChildren, useMemo } from 'react'
import { useDiagramConfig } from "../hooks/useDiagramConfig.ts"
import { CustomizeDiagramConfigContext, DiagramConfigContext } from "./DiagramConfigContext.tsx"

export const DiagramConfigProvider = ({ children }: PropsWithChildren) => {
    const { config, setConfig, getEntityConfigOrDefault, resetConfig } = useDiagramConfig()

    const diagramConfigValue = useMemo(() =>
        ({ config, getEntityConfigOrDefault }),
    [config, getEntityConfigOrDefault]
    )
    const customizeDiagramConfigValue = useMemo(() =>
        ({ setConfig, resetConfig }),
    [setConfig, resetConfig]
    )

    return (
        <DiagramConfigContext.Provider value={diagramConfigValue}>
            <CustomizeDiagramConfigContext.Provider value={customizeDiagramConfigValue}>
                {children}
            </CustomizeDiagramConfigContext.Provider>
        </DiagramConfigContext.Provider>
    )
}
